module.exports = __webpack_public_path__ + "static/tiesto_1-24574a744e670ece6c59751e3d9ea66d.jpg";